export const SET_DAO_HO = 'SET_DAO_HO';
export const SHOW_FORM_DAO_HO = 'SHOW_FORM_DAO_HO';
export const POST_DAO_HO = 'POST_DAO_HO';
export const POST_DAO_HO_SUCCESS = 'POST_DAO_HO_SUCCESS';
export const POST_DAO_HO_FAILURE = 'POST_DAO_HO_FAILURE';
export const SET_CONFIG_DAO_HO = 'SET_CONFIG_DAO_HO';
export const GET_CONFIG_SYS_DAO_HO = 'GET_CONFIG_SYS_DAO_HO';
